import {CSSProperties, FC} from 'react';


export interface IIconEcoProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconEco: FC<IIconEcoProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M2 11.664A5.67 5.67 0 0 1 7.664 6H22v5.664a5.67 5.67 0 0 1-5.664 5.664H2v-5.664Zm14.336 4.492a4.497 4.497 0 0 0 4.492-4.492V7.172H7.664a4.497 4.497 0 0 0-4.492 4.492v4.492h13.164Zm-9.732-3.931v.872h2.422v1.324h-3.94v-5.53h3.87v1.325H6.604v.779h2.01v1.23h-2.01Zm6.34.218a.984.984 0 0 1-.402.526.912.912 0 0 1-.268.117 1.12 1.12 0 0 1-.273.034.914.914 0 0 1-.47-.12 1.12 1.12 0 0 1-.351-.323 1.485 1.485 0 0 1-.218-.468 2.041 2.041 0 0 1-.074-.553c0-.17.02-.343.062-.517a1.45 1.45 0 0 1 .199-.468c.09-.137.205-.249.342-.335a.917.917 0 0 1 .495-.128c.083 0 .174.01.272.031a.931.931 0 0 1 .526.32c.075.088.136.2.183.334l1.16-.825a2.058 2.058 0 0 0-.817-.876c-.37-.22-.8-.331-1.293-.331-.42 0-.796.08-1.125.241a2.692 2.692 0 0 0-1.367 1.51 2.885 2.885 0 0 0 .015 2.041c.13.343.31.65.542.92.23.27.507.486.829.65.322.163.675.245 1.06.245.217 0 .44-.029.669-.086.228-.057.444-.14.646-.25.203-.108.383-.243.541-.404.159-.16.277-.343.355-.545l-1.239-.74Zm6.031-2.702a2.967 2.967 0 0 1 .72 1.94 2.883 2.883 0 0 1-.748 1.935 2.68 2.68 0 0 1-.84.618 2.466 2.466 0 0 1-1.075.234c-.395 0-.754-.08-1.079-.242a2.69 2.69 0 0 1-.833-.634 2.886 2.886 0 0 1-.537-.9 2.935 2.935 0 0 1-.191-1.043c0-.364.066-.714.199-1.052a2.736 2.736 0 0 1 1.402-1.507c.324-.153.68-.23 1.07-.23.395 0 .754.081 1.079.242.324.161.602.374.833.639Zm-1.086 2.916a1.57 1.57 0 0 0 .198-.471 2.207 2.207 0 0 0-.004-1.079 1.486 1.486 0 0 0-.206-.459 1.05 1.05 0 0 0-.346-.32.968.968 0 0 0-.491-.12.94.94 0 0 0-.495.125 1.068 1.068 0 0 0-.342.33c-.091.138-.159.294-.203.468a2.19 2.19 0 0 0 0 1.075c.044.173.113.328.207.463.093.135.21.244.35.327.14.083.304.124.49.124a.937.937 0 0 0 .5-.128c.14-.086.253-.197.342-.335Z" clipRule="evenodd" />
        </svg>
    );
};
